(function () {
  if (window.__jcintoTrackingInstalled) return;
  window.__jcintoTrackingInstalled = true;

  function track(name, data = {}) {
    if (!window.Shopify?.analytics?.publish) return;

    Shopify.analytics.publish("jcinto_micro_conversion", {
      event_name: name,
      product: window.location.pathname,
      ...data
    });
  }

  // 1. Room preview and size chart
  document.addEventListener("click", function (e) {

    if (e.target.closest("button.cm-launch-ar-btn")) {
      track("view_room_preview");
    }

    if (e.target.closest(
      'button[aria-controls="facets-drawer-1"]'
    )) {
      track("view_size_chart");
    }
  });

  // 2. Frame and print size selections
  document.addEventListener("change", function (e) {
    const input = e.target;

    if (!input.matches(
      'input[type="radio"][data-option-position]'
    )) return;

    const position = input.dataset.optionPosition;

    const label = Array.from(document.querySelectorAll("label"))
      .find(el => el.htmlFor === input.id);

    if (position === "1") {
      const frame = label?.getAttribute("title") ||
        label?.getAttribute("aria-label") ||
        label?.textContent.trim() ||
        input.value;

      track("select_frame_option", {
        frame_color: frame
      });
    }

    if (position === "2") {
      const size = label?.querySelector(
        ".block-swatch-separator span"
      )?.textContent.trim() || label?.textContent.trim();

      track("select_print_size", {
        print_size: size
      });
    }
  });

  // 3. Shop Pay information (Shadow DOM)
  function attachPaymentTracking() {
    const host = document.querySelector(
      "shopify-payment-terms"
    );

    const button = host?.shadowRoot?.querySelector(
      'button[aria-label="View sample plans"]'
    );

    if (!button || button.dataset.jcintoTracked) return;

    button.dataset.jcintoTracked = "true";

    button.addEventListener("click", function () {
      track("view_payment_info");
    });
  }

  attachPaymentTracking();

  const observer = new MutationObserver(attachPaymentTracking);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();